// Tudo fica dentro de `common`: e o unico namespace registrado (ns: ['common'], defaultNS:
// 'common'), entao qualquer chave de primeiro nivel fora daqui vira um namespace separado (e
// invisivel para `t()`) em vez de uma chave aninhada. Ver src/lib/i18n/index.ts.
export const ptBR = {
  common: {
    productName: 'Codout.Support',
    loading: 'Carregando...',
    retry: 'Tentar novamente',
    cancel: 'Cancelar',
    error: 'Nao foi possivel concluir esta etapa.',
    errorReference: 'Referencia do erro',
    toast: {
      dismiss: 'Dispensar',
      variant: {
        success: 'Sucesso',
        error: 'Erro',
        info: 'Informação',
        warning: 'Aviso',
      },
    },
    appError: {
      title: 'Algo deu errado',
      description: 'Encontramos um problema ao carregar esta tela. Tente novamente em instantes.',
      retry: 'Tentar novamente',
      home: 'Ir para o início',
    },
    notFound: {
      title: 'Página não encontrada',
      description: 'O endereço que você tentou abrir não existe ou foi movido.',
      home: 'Ir para o início',
    },
    auth: {
      login: {
        title: 'Entrar',
        subtitle: 'Acesse sua conta para continuar.',
        emailLabel: 'Email',
        passwordLabel: 'Senha',
        submit: 'Entrar',
        submitting: 'Entrando...',
        forgotLink: 'Esqueci minha senha',
        signupPrompt: 'Ainda não tem conta?',
        signupLink: 'Criar organização',
        errors: {
          emailRequired: 'Informe um email valido.',
          passwordRequired: 'Informe sua senha.',
        },
      },
      forgot: {
        title: 'Recuperar senha',
        subtitle: 'Informe seu email e enviaremos um link para criar uma nova senha.',
        emailLabel: 'Email',
        submit: 'Enviar link',
        submitting: 'Enviando...',
        backToLogin: 'Voltar para o login',
        sentTitle: 'Verifique seu email',
        sentDescription:
          'Se houver uma conta com esse email, enviamos um link para redefinir a senha. O link expira em algumas horas.',
        errors: {
          emailRequired: 'Informe um email valido.',
        },
      },
      reset: {
        title: 'Criar nova senha',
        subtitle: 'Escolha uma nova senha para a sua conta.',
        passwordLabel: 'Nova senha',
        passwordHint: 'Mínimo de 12 caracteres, com maiúscula, minúscula e número.',
        confirmPasswordLabel: 'Confirmar nova senha',
        submit: 'Redefinir senha',
        submitting: 'Redefinindo...',
        invalidLinkTitle: 'Link inválido ou expirado',
        invalidLinkDescription:
          'Este link de redefinição não é válido ou já expirou. Solicite um novo para continuar.',
        requestNewLink: 'Solicitar novo link',
        successTitle: 'Senha redefinida',
        successDescription: 'Sua senha foi atualizada. Agora você já pode entrar com a nova senha.',
        goToLogin: 'Ir para o login',
        errors: {
          passwordLength: 'A senha deve ter pelo menos 12 caracteres.',
          passwordMismatch: 'As senhas não coincidem.',
        },
      },
      signup: {
        title: 'Criar conta',
        subtitle: 'Leva menos de um minuto.',
        nameLabel: 'Nome',
        emailLabel: 'Email',
        passwordLabel: 'Senha',
        passwordHint: 'Minimo de 12 caracteres.',
        confirmPasswordLabel: 'Confirmar senha',
        submit: 'Criar conta',
        submitting: 'Criando conta...',
        loginPrompt: 'Ja tem conta?',
        loginLink: 'Entrar',
        errors: {
          nameRequired: 'Informe seu nome.',
          emailRequired: 'Informe um email valido.',
          passwordLength: 'A senha deve ter pelo menos 12 caracteres.',
          passwordMismatch: 'As senhas não coincidem.',
        },
      },
      userMenu: {
        openLabel: 'Abrir menu do usuario',
        signedInAs: 'Conectado como',
        logout: 'Sair',
        loggingOut: 'Saindo...',
      },
    },
    onboarding: {
      createOrganization: {
        eyebrow: 'Passo 1',
        heading: 'Sobre a sua empresa',
        subtitle: 'Sua organização reúne equipe, agentes, canais e conversas em um só lugar.',
        nameLabel: 'Nome da organização',
        websiteLabel: 'Site da empresa',
        websiteHint: 'Opcional. Vamos usar para ajudar seu agente a aprender sobre o seu negócio.',
        websitePlaceholder: 'minhaempresa.com.br',
        submit: 'Criar organização',
        submitting: 'Criando...',
        errors: {
          nameLength: 'Informe o nome da organização (mínimo 2 caracteres).',
        },
      },
      wizard: {
        title: 'Configure seu atendimento',
        stepOf: 'Passo {{current}} de {{total}}',
        stepperLabel: 'Etapas da configuração',
        steps: {
          organization: 'Organização',
          playground: 'Teste',
          connect: 'WhatsApp',
          goLive: 'Pronto',
        },
      },
      playground: {
        eyebrow: 'Experimente',
        title: 'Converse com seu agente',
        description:
          'Faça uma pergunta como se fosse seu cliente. O agente responde aqui, sem enviar nada para ninguém.',
        agentModeLabel: 'Modo',
        agentModeValue: 'Somente observação',
        loadingAgent: 'Preparando seu agente...',
        emptyTitle: 'Comece a conversa',
        emptyHint: 'Escreva uma pergunta ou experimente uma destas:',
        suggestions: {
          first: 'Quais são as formas de pagamento?',
          second: 'Qual é o prazo de entrega?',
          third: 'Como faço para trocar um produto?',
        },
        inputLabel: 'Sua mensagem',
        inputPlaceholder: 'Escreva como se fosse seu cliente...',
        send: 'Enviar',
        thinking: 'O agente está pensando...',
        handoffNote:
          'Seu agente encaminharia esta conversa para um atendente humano, com o histórico pronto.',
        firstValueTitle: 'Pronto! Seu agente já respondeu.',
        firstValueDescription:
          'É assim que ele vai ajudar sua equipe. Continue testando ou coloque-o para atender.',
        providerUnavailableTitle: 'O agente ainda não está disponível',
        providerUnavailableDescription:
          'Estamos preparando a inteligência do seu agente. Tente novamente em instantes.',
        errorTitle: 'Não foi possível obter a resposta',
        errorDescription: 'Tente novamente em instantes.',
        disclaimer: 'Este é um teste. Nenhuma mensagem é enviada aos seus clientes.',
        youLabel: 'Você',
        agentLabel: 'Agente',
        continuePrompt: 'Gostou do que viu?',
        continueCta: 'Vamos colocar para atender',
      },
      connect: {
        eyebrow: 'Passo 3',
        title: 'Conectar o WhatsApp',
        description:
          'Vamos preparar seu atendimento e conectar o número que fala com seus clientes.',
        startDescription:
          'Quando quiser, conecte o WhatsApp para o seu agente começar a acompanhar as conversas de verdade.',
        startCta: 'Conectar WhatsApp',
        instructions1: 'Abra o WhatsApp no celular que atende seus clientes.',
        instructions2: 'Toque em Aparelhos conectados.',
        instructions3: 'Aponte a câmera para o código ao lado.',
        dedicatedNumberNotice:
          'Use um número dedicado ao atendimento. O número pessoal continua separado.',
        errorDetails: 'Código {{code}} · referência {{correlationId}}',
        progress: {
          title: 'Configurando seu atendimento',
          milestones: {
            channel: 'Criando seu canal do WhatsApp',
            pairing: 'Conectando o WhatsApp',
            agent: 'Preparando seu agente de IA',
            finish: 'Concluindo a configuração',
          },
        },
        qr: {
          preparingTitle: 'Preparando o código de conexão',
          preparingDescription: 'Isso leva poucos instantes.',
          imageAlt: 'Código QR para conectar o WhatsApp',
          expiresIn: 'Este código expira em {{time}}',
          refresh: 'Gerar novo código',
          expiredTitle: 'Código expirado',
          expiredDescription:
            'Ninguém leu o código a tempo. Gere um novo e mantenha o WhatsApp aberto no celular.',
          pairingCodeLabel: 'Ou digite o código',
          connectedTitle: 'WhatsApp conectado',
          connectedDescription: 'Seu número está conectado. Finalizando a configuração...',
          unavailableTitle: 'Preparando a conexão do WhatsApp',
          unavailableDescription:
            'Estamos preparando o canal do seu WhatsApp. Isso deve levar poucos instantes.',
          errorTitle: 'Não foi possível carregar o código',
          errorDescription: 'Tente novamente em instantes.',
        },
      },
      goLive: {
        title: 'Seu atendimento está no ar',
        description:
          'A partir de agora seu agente acompanha as conversas do WhatsApp e prepara respostas para a sua equipe aprovar.',
        modeLabel: 'Modo inicial',
        modeName: 'Somente observação',
        modeDescription:
          'Nenhuma mensagem é enviada automaticamente. Você pode ativar sugestões e respostas quando quiser, nas configurações do agente.',
        primaryCta: 'Ir para a visão geral',
        comingSoon: {
          title: 'Próximos passos',
          reason: 'Estas etapas chegam quando a configuração de IA estiver disponível.',
          badge: 'Em breve',
          discovery: {
            title: 'Descoberta automática do site',
            description: 'Seu agente aprende sozinho com as páginas do seu site.',
          },
          instantAgent: {
            title: 'Agente guiado',
            description: 'Ajuste função, tom e horários em minutos.',
          },
        },
      },
    },
    knowledge: {
      pageTitle: 'Conhecimento',
      pageSubtitle: 'Ensine seu agente a responder com base no seu conteúdo.',
      discovery: {
        title: 'Ensine seu agente',
        subtitle: 'Seu agente aprende sozinho com as páginas do seu site.',
        add: {
          label: 'Aprender com uma URL',
          placeholder: 'https://minhaempresa.com.br/ajuda',
          cta: 'Aprender com esta URL',
          invalidUrl: 'Informe uma URL que comece com http:// ou https://.',
        },
        empty: {
          title: 'Importe seu site',
          description:
            'Adicione uma URL acima ou aprenda com o site que você cadastrou para o agente começar a responder com base nele.',
          cta: 'Importar meu site',
          learnFromSite: 'Aprender com o site cadastrado',
        },
        sources: {
          title: 'Fontes adicionadas',
          registeredSite: 'Site cadastrado',
          failed: 'Não foi possível aprender com esta fonte. Verifique a URL e tente de novo.',
        },
        source: {
          remove: 'Remover a fonte {{url}}',
          confirmQuestion:
            'Remover esta fonte? O agente deixa de reaprender com ela. As páginas já aprendidas permanecem até você excluí-las em Páginas aprendidas.',
          confirm: 'Sim, remover',
          cancel: 'Cancelar',
          error: 'Não foi possível remover a fonte. Tente novamente.',
        },
        websiteMissing: {
          title: 'Informe o site da empresa primeiro',
          description: 'Adicione o site da sua empresa para o agente aprender com ele.',
          label: 'Site da empresa',
          placeholder: 'minhaempresa.com.br',
          cta: 'Adicionar site e aprender',
          invalid: 'Informe um site válido (ex.: minhaempresa.com.br).',
        },
        progress: {
          title: 'Aprendendo com seu site',
          learned: '{{pages}} páginas aprendidas',
          discovered: '{{pages}} páginas encontradas',
        },
        status: {
          queued: 'Na fila',
          crawling: 'Lendo seu site',
          indexing: 'Aprendendo o conteúdo',
          ready: 'Pronto',
          failed: 'Não foi possível concluir',
        },
        ready: {
          title: 'Seu agente aprendeu com o site',
          description: '{{pages}} páginas do seu site já ajudam o agente a responder.',
          relearn: 'Aprender de novo',
        },
        failed: {
          title: 'Não foi possível aprender com seu site',
          description: 'Verifique se o site está acessível e tente de novo.',
          retry: 'Tentar de novo',
        },
        loadError: 'Não foi possível carregar o status do aprendizado.',
        retry: 'Tentar de novo',
      },
      documents: {
        title: 'Páginas aprendidas',
        empty: 'Nenhuma página aprendida ainda.',
        loadError: 'Não foi possível carregar as páginas aprendidas.',
        summary: '{{ready}} de {{total}} prontas',
        columns: {
          name: 'Página',
          visibility: 'Visibilidade',
          status: 'Status',
          learnedAt: 'Aprendida em',
          actions: 'Ações',
        },
        status: {
          ready: 'Pronta',
          processing: 'Processando',
          pending: 'Na fila',
          failed: 'Falhou',
        },
        visibility: {
          customer: 'Visível',
          internal: 'Uso interno',
        },
        delete: {
          action: 'Excluir {{name}}',
          confirmQuestion: 'Excluir? Isto remove o documento e o que o agente aprendeu dele.',
          confirm: 'Sim, excluir',
          cancel: 'Cancelar',
          error: 'Não foi possível excluir o documento. Tente novamente.',
        },
      },
      upload: {
        title: 'Envie documentos',
        subtitle: 'Além do seu site, o agente também aprende com os arquivos que você enviar aqui.',
        dropzone: {
          instruction: 'Arraste arquivos aqui ou selecione do computador',
          hint: 'TXT, Markdown, PDF, Word e Excel · até 10 MB por arquivo',
          button: 'Selecionar arquivos',
          inputLabel: 'Selecionar arquivos para enviar',
        },
        internal: {
          label: 'Uso interno',
          hint: 'O agente considera este conteúdo, mas não o repete ao cliente.',
        },
        list: {
          title: 'Arquivos enviados',
        },
        status: {
          uploading: 'Enviando',
          processing: 'Processando',
          ready: 'Pronto',
          error: 'Falhou',
        },
        item: {
          dismiss: 'Remover {{name}} da lista',
        },
        rejected: {
          title: 'Alguns arquivos não foram aceitos',
          unsupportedType:
            '{{name}}: formato não suportado. Envie TXT, Markdown, PDF, Word ou Excel.',
          fileTooLarge: '{{name}}: arquivo acima de 10 MB.',
          emptyFile: '{{name}}: o arquivo está vazio.',
        },
        errors: {
          unsupportedType: 'Formato não suportado. Envie TXT, Markdown, PDF, Word ou Excel.',
          fileTooLarge: 'Arquivo acima do tamanho máximo de 10 MB.',
          emptyFile: 'O arquivo está vazio.',
          unreadable: 'Não conseguimos ler o conteúdo deste arquivo.',
          contentTooLarge:
            'O conteúdo do documento é grande demais para processar. Tente dividi-lo em arquivos menores.',
          aiNotConfigured: 'O processamento por IA ainda não está disponível. Fale com o suporte.',
          processingFailed: 'Não foi possível processar o documento. Tente enviar novamente.',
          processingTimeout:
            'O documento é grande e o processamento passou do tempo limite. Tente dividi-lo em arquivos menores.',
          uploadTimeout: 'O envio demorou demais. Verifique sua conexão e tente novamente.',
          statusUnavailable: 'Não foi possível verificar o andamento. Atualize a página.',
          generic: 'Não foi possível enviar o arquivo. Tente novamente.',
        },
      },
    },
    agents: {
      pageTitle: 'Agentes',
      pageSubtitle:
        'Veja seus agentes, escolha como cada um atua e converse com eles antes de ativar.',
      loading: 'Preparando seus agentes...',
      loadError: 'Não foi possível carregar seus agentes.',
      actionFailed: 'Não foi possível concluir a ação.',
      empty: {
        title: 'Nenhum agente por aqui ainda',
        description:
          'Seu agente é criado durante a configuração inicial. Se você começou agora, atualize em instantes.',
        refresh: 'Atualizar',
      },
      card: {
        statusLabel: 'Status',
        testCta: 'Testar agente',
        hideTestCta: 'Ocultar teste',
        edit: 'Editar',
        enable: 'Ativar',
        disable: 'Desativar',
      },
      toast: {
        created: 'Agente "{{name}}" criado',
        updated: 'Agente atualizado',
        enabled: 'Agente ativado',
        disabled: 'Agente desativado',
      },
      create: {
        cta: 'Criar agente',
        title: 'Criar um agente',
        subtitle:
          'Dê um nome e, se quiser, descreva a persona e as instruções. Nasce só observando.',
        cancel: 'Cancelar',
        submit: 'Criar agente',
        submitting: 'Criando...',
        errorTitle: 'Não foi possível criar o agente',
      },
      edit: {
        title: 'Editar agente',
        subtitle: 'Ajuste o nome, a descrição e as instruções do agente.',
        cancel: 'Cancelar',
        save: 'Salvar',
        saving: 'Salvando...',
      },
      persona: {
        nameLabel: 'Nome do agente',
        namePlaceholder: 'Ex.: Suporte',
        descriptionLabel: 'Descrição',
        descriptionPlaceholder: 'Uma frase sobre o que este agente faz (opcional).',
        systemPromptLabel: 'Instruções',
        systemPromptPlaceholder: 'Como o agente deve se comportar, tom, limites...',
        systemPromptHint:
          'As instruções guiam as respostas. Um agente sem instruções não pode responder sozinho (modo automático).',
        templates: {
          title: 'Começar de um modelo',
          hint: 'Escolha o mais parecido com o seu negócio e ajuste o texto. Você pode editar tudo depois.',
          replaceQuestion: 'Substituir as instruções atuais pelo modelo “{{name}}”?',
          replace: 'Substituir',
          cancel: 'Manter as atuais',
          fallbackCompany: 'nossa empresa',
          items: {
            general: {
              name: 'Atendimento geral',
              text: 'Você é o assistente de atendimento da {{company}}. Responda em português, de forma cordial, clara e objetiva, em mensagens curtas (como numa conversa de WhatsApp).\n\n- Use apenas as informações da base de conhecimento e das consultas disponíveis. Se não souber ou não tiver certeza, não invente: diga que vai verificar e transfira para um atendente humano.\n- Se o cliente pedir para falar com uma pessoa, transfira sem insistir.\n- Faça uma pergunta por vez quando precisar de mais detalhes.\n- Nunca peça senhas, códigos de verificação ou dados completos de cartão.\n- Encerre perguntando se pode ajudar em algo mais.',
            },
            techSupport: {
              name: 'Suporte técnico (software)',
              text: 'Você é o suporte técnico da {{company}}. Ajude o cliente a resolver dúvidas e problemas no uso do sistema, em português, com linguagem simples e sem jargões.\n\n- Antes de responder, entenda o problema: pergunte a tela ou funcionalidade, o que o cliente tentou fazer e a mensagem de erro exata, uma pergunta por vez.\n- Dê o passo a passo numerado e curto, com os nomes dos menus exatamente como aparecem no sistema.\n- Use apenas a base de conhecimento e as consultas disponíveis; não invente funcionalidades, prazos ou configurações.\n- Se parecer um erro do sistema, indisponibilidade ou perda de dados, ou se após duas tentativas o problema continuar, transfira para um atendente humano com um resumo do que já foi tentado.\n- Nunca peça a senha do cliente.',
            },
            sales: {
              name: 'Vendas e pré-venda',
              text: 'Você é o consultor de vendas da {{company}}. Seu objetivo é entender a necessidade do cliente e mostrar como podemos ajudar, sem pressão.\n\n- Faça perguntas para entender o contexto (tamanho do negócio, o que usa hoje, principal dificuldade), uma de cada vez.\n- Apresente apenas planos, preços, condições e prazos que estejam na base de conhecimento; nunca invente descontos ou promessas.\n- Destaque os benefícios ligados ao que o cliente contou.\n- Quando o cliente quiser contratar, pedir uma proposta personalizada ou negociar condições, transfira para um atendente humano com um resumo da conversa.\n- Seja cordial e objetivo, com mensagens curtas.',
            },
            ecommerce: {
              name: 'Loja virtual (pedidos e entregas)',
              text: 'Você é o atendimento da loja {{company}}. Ajude com dúvidas sobre produtos, pedidos, entregas, trocas e devoluções, em português e com mensagens curtas.\n\n- Para falar de um pedido, use as consultas disponíveis; se não encontrar o pedido, peça o número do pedido ou o e-mail usado na compra.\n- Informe prazos e políticas (frete, troca, devolução, garantia) apenas conforme a base de conhecimento.\n- Não prometa reembolso, estorno, brinde ou exceção à política: nesses casos, e em reclamações de produto com defeito ou entrega não recebida, transfira para um atendente humano.\n- Seja empático com atrasos e problemas, sem culpar transportadoras ou terceiros.\n- Nunca peça dados completos de cartão.',
            },
            scheduling: {
              name: 'Agendamentos (clínicas e serviços)',
              text: 'Você é a recepção virtual da {{company}}. Atenda com cordialidade e ajude com informações sobre serviços, horários, endereço, preparo e agendamentos, em mensagens curtas.\n\n- Informe serviços, valores, convênios e horários apenas conforme a base de conhecimento.\n- Para marcar, remarcar ou cancelar um horário, colete o nome completo, o serviço desejado e a preferência de dia e turno, e transfira para um atendente humano concluir.\n- Não dê orientações de diagnóstico ou tratamento; nesses casos, oriente a falar com o profissional.\n- Em situação de urgência ou emergência, oriente a procurar atendimento imediato e transfira para um humano.\n- Trate dados pessoais com discrição.',
            },
            billing: {
              name: 'Financeiro e cobrança',
              text: 'Você é o atendimento financeiro da {{company}}. Ajude com dúvidas sobre faturas, boletos, formas de pagamento e situação da assinatura, em português, com respeito e clareza.\n\n- Use as consultas disponíveis para as informações do cliente; não suponha valores, datas ou status.\n- Explique como emitir a segunda via e as formas de pagamento conforme a base de conhecimento.\n- Não negocie descontos, parcelamentos, isenção de multa ou estornos: transfira para um atendente humano com um resumo do pedido.\n- Em contestação de cobrança ou com o cliente insatisfeito, transfira para um humano.\n- Nunca peça senha, código de verificação ou dados completos de cartão, e nunca envie links de pagamento que não estejam na base de conhecimento.',
            },
          },
        },
      },
      statuses: {
        Draft: 'Rascunho',
        Active: 'Ativo',
        Disabled: 'Desativado',
      },
      playground: {
        title: 'Testar este agente',
        subtitle: 'Converse como se fosse seu cliente. Nada é enviado aos seus clientes.',
      },
      mode: {
        currentLabel: 'Modo atual',
        currentBadge: 'Atual',
        sectionTitle: 'Como este agente atua',
        sectionHint: 'Você troca o modo quando quiser. O modo atual fica sempre visível.',
        toast: {
          changed: 'Modo atualizado para {{mode}}',
        },
        confirm: {
          title: 'Ligar resposta automática?',
          description:
            'Neste modo o agente responde seus clientes sozinho, sem alguém revisar antes. Você pode voltar para sugestões quando quiser.',
          confirmCta: 'Sim, ligar resposta automática',
          cancel: 'Cancelar',
        },
        errors: {
          prerequisiteTitle: 'Ainda não dá para ligar a resposta automática',
          tenantNotAllowed:
            'Sua organização ainda não está liberada para resposta automática. Fale com o suporte.',
          channelNotReady:
            'Conecte e verifique seu canal de atendimento antes de ligar a resposta automática.',
          agentNotEligible:
            'Este agente precisa estar ativo para responder sozinho. Continue em sugestões por enquanto.',
          agentMissingInstructions:
            'Falta preencher as Instruções deste agente — elas dizem como ele deve responder. Abra “Editar agente”, escreva as instruções e tente de novo. (Isto não tem relação com os materiais da base de conhecimento.)',
          prerequisiteGeneric:
            'Alguns requisitos ainda não foram atendidos. Verifique seu canal e tente de novo.',
          confirmationRequired: 'Confirme para ligar a resposta automática.',
          notFound: 'Este agente não está mais disponível. Atualize a página.',
          generic: 'Não foi possível mudar o modo. Tente novamente.',
        },
      },
      modes: {
        observeOnly: {
          label: 'Observando',
          description: 'O agente acompanha as conversas e aprende, sem responder nada.',
        },
        suggest: {
          label: 'Sugerindo',
          description: 'O agente prepara respostas para sua equipe aprovar antes de enviar.',
        },
        autoReply: {
          label: 'Resposta automática',
          description: 'O agente responde seus clientes sozinho. Exige confirmação para ativar.',
        },
      },
    },
    channels: {
      pageTitle: 'Canais',
      pageSubtitle: 'Veja seus canais de atendimento e o status de conexão de cada um.',
      loading: 'Carregando seus canais...',
      loadError: 'Não foi possível carregar seus canais.',
      empty: {
        title: 'Nenhum canal conectado ainda',
        description:
          'Seu WhatsApp é conectado na configuração inicial da sua organização. Se você acabou de começar, atualize em instantes.',
        refresh: 'Atualizar',
      },
      status: {
        connected: 'Conectado',
        waiting: 'Aguardando conexão',
        disconnected: 'Desconectado',
        failed: 'Falhou',
      },
      card: {
        typeWhatsApp: 'WhatsApp',
        createdLabel: 'Criado em {{date}}',
        updatedLabel: 'Atualizado em {{date}}',
        reconnect: 'Reconectar',
        regenerate: 'Gerar novo código',
        close: 'Fechar',
        connectedHint: 'Seu WhatsApp está conectado.',
      },
      reconnect: {
        title: 'Reconectar o WhatsApp',
        description:
          'Leia o código com o mesmo WhatsApp que atende seus clientes para reconectar este canal.',
      },
    },
    webchat: {
      pageTitle: 'WebChat',
      pageSubtitle:
        'Coloque um chat com IA no seu próprio site. Crie um widget, copie o código e seus usuários logados já são reconhecidos.',
      loading: 'Carregando seus widgets...',
      loadError: 'Não foi possível carregar seus widgets.',
      loadErrorHint: 'Atualize a página em instantes.',
      empty: {
        title: 'Nenhum widget ainda',
        description: 'Crie seu primeiro widget acima para embutir o chat no seu site.',
      },
      create: {
        title: 'Criar um widget',
        subtitle: 'Dê um nome e informe os sites (origens) onde ele poderá aparecer.',
        nameLabel: 'Nome do widget',
        namePlaceholder: 'Ex.: Site principal',
        originsLabel: 'Origens autorizadas',
        originsHint: 'Uma por linha (ex.: https://app.seucliente.com). Você pode ajustar depois.',
        submit: 'Criar widget',
        submitting: 'Criando...',
        errorTitle: 'Não foi possível criar o widget',
        errorGeneric: 'Tente novamente em instantes.',
      },
      card: {
        active: 'Ativo',
        disabled: 'Desativado',
        enable: 'Ativar',
        disable: 'Desativar',
        originsLabel: 'Origens autorizadas',
        editOrigins: 'Editar',
        saveOrigins: 'Salvar origens',
        cancel: 'Cancelar',
        noOrigins: 'Nenhuma origem cadastrada — o widget não aparecerá em nenhum site ainda.',
        rotate: 'Gerar novo segredo',
        rotating: 'Gerando...',
        rotateHint: 'Gera um novo signing secret e invalida o anterior.',
        actionFailedTitle: 'Não foi possível concluir a ação',
        actionFailedGeneric: 'Tente novamente em instantes.',
      },
      toast: {
        created: 'Widget criado',
        enabled: 'Widget ativado',
        disabled: 'Widget desativado',
        originsSaved: 'Origens atualizadas',
      },
      credentials: {
        title: 'Credenciais do widget',
        subtitle: 'Copie e guarde agora — o signing secret não será mostrado de novo.',
        done: 'Concluído',
        secretWarningTitle: 'Guarde o signing secret com segurança',
        secretWarning:
          'O signing secret fica só no seu backend, que assina os tokens de identidade dos seus usuários logados. Nunca o exponha no navegador.',
        publishableKey: 'Publishable key (pública)',
        signingSecret: 'Signing secret (mostrado uma vez)',
        snippet: 'Código de embed',
        snippetTokenPlaceholder: '<token assinado pelo seu backend>',
        copy: 'Copiar',
        copied: 'Copiado!',
        copyFailed: 'Falhou — selecione e copie',
        tokenNote:
          'O token assinado é gerado pelo seu backend com o signing secret, para cada usuário logado. Veja a documentação de emissão de token.',
      },
    },
    integrations: {
      pageTitle: 'Integrações',
      pageSubtitle:
        'Veja os sistemas do seu negócio que o agente pode consultar ao vivo ao atender.',
      loading: 'Carregando suas integrações...',
      loadError: 'Não foi possível carregar suas integrações.',
      intro: {
        title: 'Dados que mudam, respondidos na hora',
        description:
          'Para responder o que muda — como pedidos e planos — o agente consulta os sistemas do seu negócio ao vivo. As consultas são apenas de leitura e acontecem com segurança.',
      },
      health: {
        healthy: 'Conectado',
        unavailable: 'Indisponível',
      },
      card: {
        toolsHint: 'Seu agente pode consultar isto ao vivo ao responder um cliente:',
        toolsLabel: 'Consultas ao vivo disponíveis',
        noTools: 'Nenhuma consulta disponível neste conector ainda.',
      },
      riskLevels: {
        readOnly: 'Leitura',
        lowRiskWrite: 'Escrita',
        highRiskWrite: 'Escrita sensível',
        destructive: 'Destrutiva',
      },
      empty: {
        title: 'Nenhuma integração disponível ainda',
        description:
          'As integrações com os sistemas do seu negócio aparecem aqui. Quando disponíveis, seu agente poderá consultar dados ao vivo — como pedidos e planos — para responder seus clientes.',
        refresh: 'Atualizar',
        roadmapNote:
          'Conectar seus próprios sistemas (importando a sua API) faz parte do roadmap do produto.',
      },
    },
    billing: {
      title: 'Planos e uso',
      subtitle:
        'Acompanhe seu teste, seu saldo de interações de IA e o consumo da sua organização.',
      interactions: 'interações',
      plans: {
        title: 'Planos',
        subtitle:
          'Escolha o plano ideal. O pagamento acontece numa página segura; nada de cartão salvo aqui.',
        perMonth: '/mês',
        priceUnset: 'Em definição',
        priceUnsetHint: 'O valor deste plano ainda está em definição.',
        current: 'Plano atual',
        awaitingPayment: 'Aguardando pagamento',
        subscribe: 'Assinar',
        changeTo: 'Mudar para este plano',
        scheduled: 'A partir da próxima renovação',
        upgradeCreated: 'Fatura da diferença gerada. Ao pagar, o novo plano vale na hora.',
        downgradeScheduled: 'Troca agendada para a próxima renovação.',
        subscribing: 'Gerando fatura…',
        contactSales: 'Falar com vendas',
        onlyOwner: 'Somente o proprietário pode assinar ou cancelar.',
        gatewayUnavailable: 'O pagamento está indisponível no momento. Tente novamente mais tarde.',
        names: {
          starter: 'Starter',
          professional: 'Professional',
          enterprise: 'Enterprise',
        },
        limits: {
          interactions: '{{value}} interações de IA por mês',
          channels: '{{value}} canal(is)',
          agents: '{{value}} agente(s)',
          users: '{{value}} pessoa(s) na equipe',
          storage: '{{value}} MB de conhecimento',
          triageOn: 'Triagem incluída',
          triageOff: 'Sem Triagem',
          custom: 'Limites sob medida',
        },
      },
      profile: {
        title: 'Dados de cobrança',
        description: 'Usados para emitir as faturas. O documento aparece sempre mascarado.',
        legalName: 'Nome ou razão social',
        taxId: 'CPF ou CNPJ',
        email: 'E-mail para cobrança',
        save: 'Salvar dados',
        saveAndSubscribe: 'Salvar e assinar',
        saved: 'Dados de cobrança salvos.',
        empty: 'Nenhum dado de cobrança informado ainda.',
        edit: 'Editar',
      },
      invoice: {
        title: 'Fatura em aberto',
        number: 'Fatura {{number}}',
        due: 'Vence em {{date}}',
        payNow: 'Pagar agora',
        issuing: 'Estamos gerando o link de pagamento. Ele aparece aqui em instantes.',
        pixTitle: 'Pix copia e cola',
        copy: 'Copiar código Pix',
        copied: 'Código Pix copiado.',
        awaitingActivation: 'Após o pagamento, seu plano é ativado automaticamente.',
      },
      packs: {
        title: 'Interações extras',
        subtitle:
          'Compre interações de IA avulsas. Valem por {{months}} meses e são usadas depois da cota do mês.',
        requiresPlan: 'Interações extras ficam disponíveis com um plano ativo.',
        credits: '{{value}} interações',
        buy: 'Comprar',
        ordered: 'Fatura gerada. As interações entram assim que o pagamento for confirmado.',
      },
      invoices: {
        title: 'Faturas',
        empty: 'Nenhuma fatura ainda',
        emptyDescription: 'Quando você assinar um plano, as faturas aparecem aqui.',
        columns: {
          number: 'Número',
          date: 'Emitida em',
          amount: 'Valor',
          status: 'Situação',
          action: 'Ação',
        },
        statuses: {
          Issuing: 'Gerando',
          Issued: 'Em aberto',
          Paid: 'Paga',
          Overdue: 'Vencida',
          Canceled: 'Cancelada',
          Refunded: 'Estornada',
        },
        pay: 'Pagar',
      },
      subscription: {
        statuses: {
          PendingFirstPayment: 'Aguardando pagamento',
          Active: 'Ativa',
          PastDue: 'Pagamento pendente',
          Canceled: 'Cancelada',
        },
        cancelScheduled: 'Cancelamento agendado para {{date}}.',
      },
      cancel: {
        title: 'Cancelar plano',
        description:
          'O plano continua valendo até o fim do período pago e as interações já pagas seguem disponíveis até lá.',
        action: 'Cancelar plano',
        confirmTitle: 'Cancelar o plano?',
        confirmDescription:
          'Seu plano vale até o fim do período pago. Depois disso, o agente pausa quando as interações acabarem.',
        confirm: 'Sim, cancelar',
        keep: 'Manter plano',
        done: 'Cancelamento registrado.',
      },
      errors: {
        plan_unavailable: 'Este plano não está disponível para assinatura.',
        billing_profile_required: 'Informe os dados de cobrança antes de assinar.',
        invalid_tax_id: 'CPF ou CNPJ inválido.',
        validation_error: 'Confira os dados informados.',
        subscription_already_active: 'Você já tem uma assinatura ativa.',
        subscription_not_found: 'Nenhuma assinatura ativa.',
        payment_gateway_not_configured: 'O pagamento está indisponível no momento.',
        payment_gateway_error: 'Não foi possível falar com o serviço de pagamento. Tente de novo.',
        generic: 'Não foi possível concluir. Tente novamente.',
        credit_pack_unavailable: 'Este pacote não está disponível.',
        credit_pack_requires_subscription: 'Interações extras exigem um plano ativo.',
        plan_limit_reached:
          'Você atingiu o limite do seu plano. Escolha um plano maior para continuar.',
        plan_required: 'Escolha um plano para continuar.',
      },
      states: {
        Trial: 'Teste grátis',
        TrialEnded: 'Teste encerrado',
        Active: 'Plano ativo',
        PastDue: 'Pagamento pendente',
        Canceled: 'Plano cancelado',
      },
      current: {
        title: 'Estado atual',
        available: 'Interações disponíveis',
        trialEndsAt: 'Teste até {{date}}',
        periodEnd: 'Período até {{date}}',
        plansSoon:
          'A escolha de plano chega aqui em breve. Até lá, seu atendimento segue normalmente.',
        loadError: 'Não foi possível carregar o estado da sua organização.',
      },
      usage: {
        title: 'Uso neste período',
        windowLabel: 'Período',
        window: 'Últimos {{days}} dias',
        loadError: 'Não foi possível carregar o consumo.',
        buckets: {
          title: 'Saldo por origem',
          empty: 'Nenhum saldo ativo no momento.',
          consumedOf: '{{consumed}} de {{credits}} usadas',
          expiresAt: 'Vale até {{date}}',
          noExpiry: 'Sem validade',
          kinds: {
            Trial: 'Teste grátis',
            PlanAllowance: 'Cota do plano',
            TopUp: 'Interações extras',
            Adjustment: 'Cortesia',
          },
        },
        byKind: {
          title: 'Consumo por tipo',
          kinds: {
            AgentExecution: 'Respostas do agente',
            PlaygroundExecution: 'Playground',
            TriageRun: 'Triagem',
            AudioTranscription: 'Transcrição de áudio',
          },
        },
        daily: {
          title: 'Consumo diário',
          ariaLabel: 'Interações de IA consumidas por dia',
          series: 'Interações',
        },
        empty: {
          title: 'Nenhuma interação consumida neste período',
          description: 'Teste o agente no Playground para ver o consumo aparecer aqui.',
          action: 'Abrir Agentes',
        },
      },
      noPermission: {
        title: 'Detalhe de consumo restrito',
        description: 'Somente o proprietário e os administradores veem o detalhe de consumo.',
      },
      banner: {
        paused:
          'O agente está pausado: suas interações de IA acabaram. As mensagens continuam chegando e sua equipe pode responder.',
        trialEnded: 'Seu teste terminou. Escolha um plano para continuar com o agente.',
        pastDue: 'Há um pagamento pendente. Regularize para manter seu plano.',
        openInvoice: 'Sua fatura está disponível. Após o pagamento, seu plano é ativado.',
        lowBalance: 'Restam {{available}} interações neste período.',
        trial: 'Teste grátis: {{available}} interações até {{date}}. Sem cartão.',
        actions: {
          viewPlans: 'Ver planos e uso',
          viewUsage: 'Ver uso',
          payNow: 'Pagar agora',
          dismiss: 'Dispensar aviso',
        },
      },
      topbar: {
        ariaLabel: 'Saldo de interações de IA: {{value}}. Abrir Planos e uso.',
        pausedAriaLabel: 'Agente pausado: sem interações de IA. Abrir Planos e uso.',
        paused: 'Pausado',
      },
      dashboard: {
        title: 'Interações de IA',
        available: '{{value}} disponíveis',
        consumedOf: '{{consumed}} de {{credits}} usadas',
        trialEndsAt: 'Teste até {{date}}',
        paused: 'Agente pausado: sem interações de IA',
        viewUsage: 'Ver uso',
        viewPlans: 'Ver planos e uso',
        loadError: 'Não foi possível carregar o saldo.',
      },
      paused: {
        badge: 'Pausado: sem créditos',
        title: 'O agente está pausado: as interações de IA acabaram.',
        description: 'As mensagens continuam chegando e sua equipe pode responder.',
        action: 'Ver planos e uso',
      },
      onboarding: {
        organization:
          'Sua organização começa com um teste grátis de {{credits}} interações por {{days}} dias. Sem cartão.',
        goLive: 'Quando o teste acabar, escolha um plano em Planos e uso.',
      },
    },
    shell: {
      sidebar: {
        collapse: 'Recolher menu',
        expand: 'Expandir menu',
        openMenu: 'Abrir menu de navegacao',
        closeMenu: 'Fechar menu de navegacao',
      },
      nav: {
        dashboard: 'Visão geral',
        desk: 'Atendimento',
        pendencias: 'Pendências',
        agents: 'Agentes',
        knowledge: 'Conhecimento',
        channels: 'Canais',
        webchat: 'WebChat',
        integrations: 'Integrações',
        analytics: 'Analytics',
        audit: 'Auditoria',
        team: 'Equipe',
        billing: 'Planos e uso',
        settings: 'Configurações',
      },
      tenantSwitcher: {
        ariaLabel: 'Selecionar organização',
        openLabel: 'Trocar de organização',
        current: 'Organização atual',
      },
    },
    dashboard: {
      greeting: 'Olá, {{name}}',
      organization: {
        title: 'Sua organização',
        nameLabel: 'Nome',
        slugLabel: 'Identificador',
        statusLabel: 'Status',
        createdAtLabel: 'Criada em',
        statuses: {
          Provisioning: 'Provisionando',
          Active: 'Ativa',
          Suspended: 'Suspensa',
          Disabled: 'Desativada',
          Deleted: 'Excluída',
        },
      },
      activity: {
        title: 'Atividade dos últimos {{days}} dias',
        inbound: 'Conversas recebidas',
        executions: 'Execuções do agente',
        autoReplies: 'Respostas automáticas',
        suggestions: 'Sugestões à equipe',
        loadError: 'Não foi possível carregar a atividade recente.',
      },
      members: {
        title: 'Equipe',
        countSingular: '{{count}} pessoa na equipe',
        countPlural: '{{count}} pessoas na equipe',
        viewAll: 'Ver equipe',
        loadError: 'Não foi possível carregar a equipe.',
      },
      modules: {
        title: 'Explore o painel',
        subtitle: 'Acesse as áreas do seu atendimento.',
      },
      shortcuts: {
        desk: 'Veja e responda as conversas dos seus clientes.',
        agents: 'Configure como o agente atende e teste no Playground.',
        knowledge: 'Ensine o agente com seu site e seus documentos.',
        channels: 'Conecte e acompanhe seus canais de atendimento.',
        integrations: 'Veja o que o agente pode consultar nos seus sistemas.',
        analytics: 'Acompanhe o desempenho do seu atendimento.',
      },
    },
    desk: {
      title: 'Atendimento',
      agentMode: {
        label: 'Agente',
        loading: 'Carregando...',
        observeOnly: 'Somente observação',
        suggest: 'Sugerindo',
        autoReply: 'Resposta automática',
        none: 'Sem agente ativo',
      },
      filters: {
        label: 'Filtrar conversas',
        open: 'Abertas',
        pending: 'Aguardando humano',
        resolved: 'Resolvidas',
        all: 'Todas',
      },
      statuses: {
        open: 'Aberta',
        pending: 'Aguardando humano',
        resolved: 'Resolvida',
      },
      list: {
        emptyTitle: 'Nenhuma conversa por aqui',
        emptyDescription:
          'Quando seus clientes enviarem mensagens no WhatsApp, elas aparecem aqui para você responder.',
        reload: 'Atualizar',
        unknownContact: 'Contato sem nome',
        loadFailed: 'Não foi possível carregar as conversas.',
      },
      detail: {
        noneSelectedTitle: 'Selecione uma conversa',
        noneSelectedDescription: 'Escolha uma conversa na lista para ver as mensagens e responder.',
        back: 'Voltar',
        loadFailed: 'Não foi possível carregar a conversa.',
      },
      channelNotReady: {
        title: 'Seu canal de atendimento ainda não está pronto',
        description: 'Conecte o WhatsApp para começar a receber e responder conversas por aqui.',
        action: 'Conectar canal',
      },
      header: {
        resolve: 'Resolver',
        reopen: 'Reabrir',
        resolved: 'Conversa resolvida',
        reopened: 'Conversa reaberta',
      },
      triageCard: {
        title: 'Triagem',
        notTriaged: 'Esta conversa ainda não foi analisada.',
        excluded: 'Esta conversa está fora da triagem.',
        exclude: 'Não triar esta conversa',
        includeBack: 'Voltar a triar esta conversa',
        important: 'Contato importante',
        notImportant: 'Marcar contato como importante',
        updated: 'Preferência atualizada',
        actionFailed: 'Não foi possível atualizar a preferência.',
      },
      thread: {
        internalNote: 'Nota interna',
        empty: 'Ainda não há mensagens nesta conversa.',
        authors: {
          agent: 'Agente de IA',
          operator: 'Equipe',
          operatorPhone: 'Você, pelo celular',
        },
        attachment: 'Anexo',
        transcript: 'Transcrição',
        media: {
          open: 'Abrir a imagem em uma nova aba',
          imageAlt: 'Imagem enviada na conversa',
          download: 'Baixar',
          document: 'Documento',
        },
      },
      agent: {
        panelTitle: 'Agente de IA',
        suggestionTitle: 'Sugestão do agente',
        postedAsNote: 'Publicada como nota',
        notPosted: 'Não publicada',
        autoReplied: 'Respondida ao cliente',
        noText: 'O agente não gerou um texto de resposta.',
        empty: 'O agente ainda não analisou esta conversa.',
        riskLevels: {
          none: 'Nenhum',
          low: 'Baixo',
          medium: 'Médio',
          high: 'Alto',
        },
        trace: {
          risk: 'Risco',
          model: 'Modelo',
          tokens: 'Tokens',
          duration: 'Duração',
          durationValue: '{{ms}} ms',
        },
      },
      composer: {
        modeLabel: 'Tipo de mensagem',
        reply: 'Responder',
        note: 'Nota interna',
        noteHint: 'Visível apenas para a equipe. O cliente não recebe esta mensagem.',
        sendFailed: 'Não foi possível enviar.',
        replyPlaceholder: 'Escreva sua resposta ao cliente...',
        notePlaceholder: 'Escreva uma nota para a equipe...',
        send: 'Enviar',
        saveNote: 'Salvar nota',
        replySent: 'Resposta enviada',
        noteSaved: 'Nota interna adicionada',
      },
      ticket: {
        label: 'Chamado #{{number}}',
        statusWaiting: 'Aguardando atendente',
        statusInProgress: 'Em atendimento',
        openedAgo: 'aberto há {{time}}',
        openedOffline: 'Aberto fora do atendimento',
        listWaiting: '#{{number}} · aguardando há {{time}}',
        listInProgress: '#{{number}} · em atendimento',
        waitingNow: 'instantes',
        waitingMinutes: '{{count}} min',
        waitingHours: '{{count}} h',
        waitingDays: '{{count}} d',
        reason: 'Motivo',
        summary: 'Resumo da IA',
        owner: 'Responsável',
        ownerMe: 'Você',
        ownerNobody: 'Ninguém assumiu ainda',
        aiPaused:
          'A IA está pausada nesta conversa até o chamado ser devolvido ou a conversa ser resolvida.',
        takeOver: 'Assumir',
        takeOverConversation: 'Assumir conversa',
        returnToAgent: 'Devolver para a IA',
        tookOver: 'Você assumiu a conversa',
        returned: 'Conversa devolvida para a IA',
        actionFailed: 'Não foi possível concluir a ação.',
        reasons: {
          UserRequestedHuman: 'O cliente pediu para falar com uma pessoa',
          LowConfidence: 'A IA não tinha segurança para responder',
          CriticalIssue: 'Problema crítico',
          FinancialIssue: 'Assunto financeiro',
          Complaint: 'Reclamação',
          SensitiveRequest: 'Pedido sensível',
          PolicyBlocked: 'Bloqueado por política',
          MissingInformation: 'Faltou informação para resolver',
          AgentFailure: 'A IA não conseguiu concluir a consulta',
          OperatorTakeover: 'Um atendente assumiu a conversa',
          other: 'Transferência para atendimento humano',
        },
      },
    },
    triage: {
      title: 'Pendências',
      subtitle: 'O que espera a sua resposta, o que espera o contato e as tarefas em aberto.',
      loadFailed: 'Não foi possível carregar as pendências.',
      disabled: {
        title: 'A triagem está desligada',
        description:
          'Ligue a triagem para ver aqui, por prioridade, quem espera a sua resposta, um resumo de cada conversa e um rascunho pronto para enviar.',
        action: 'Ligar em Configurações',
      },
      disabledBanner: {
        title: 'A triagem está desligada',
        description:
          'As conversas abaixo esperam você, mas sem a triagem não há resumo, prioridade nem rascunho.',
      },
      awaitingYou: {
        title: 'Esperando você',
        emptyTitle: 'Tudo respondido',
        emptyDescription: 'Nenhuma conversa espera a sua resposta agora.',
      },
      awaitingThem: {
        title: 'Esperando eles',
        empty: 'Nenhuma conversa aguardando o contato.',
        repliedAgo: 'respondida há {{time}}',
      },
      card: {
        waitingFor: 'esperando há {{time}}',
        importantContact: 'Contato importante',
        excluded: 'Fora da triagem',
        notTriaged: 'Ainda não analisada',
        noSummary: 'A triagem ainda não analisou esta conversa.',
        need: 'Precisa de',
        draft: 'Rascunho sugerido',
        editDraft: 'Editar rascunho',
        send: 'Enviar',
        edit: 'Editar',
        doneEditing: 'Pronto',
        dismiss: 'Ignorar',
        sent: 'Resposta enviada',
        sendFailed: 'Não foi possível enviar a resposta.',
        dismissed: 'Rascunho ignorado',
        actionFailed: 'Não foi possível concluir a ação.',
        openConversation: 'Abrir conversa',
      },
      tasks: {
        title: 'Tarefas',
        filterLabel: 'Filtrar tarefas',
        filters: { open: 'Abertas', done: 'Concluídas' },
        newTaskLabel: 'Nova tarefa',
        newTaskPlaceholder: 'Nova tarefa...',
        add: 'Adicionar',
        created: 'Tarefa criada',
        complete: 'Concluir',
        dismissTask: 'Descartar',
        done: 'Concluída',
        suggestedByAi: 'sugerida pela IA',
        fromConversation: 'Conversa com {{contact}}',
        emptyTitle: 'Nenhuma tarefa aberta',
        emptyDescription:
          'Compromissos e pedidos detectados nas conversas aparecem aqui. Você também pode criar uma tarefa à mão.',
        emptyDoneTitle: 'Nenhuma tarefa concluída',
        emptyDoneDescription: 'As tarefas que você concluir ficam aqui.',
        actionFailed: 'Não foi possível concluir a ação.',
      },
    },
    presence: {
      openLabel: 'Alterar meu status de atendimento',
      available: 'Disponível',
      away: 'Ausente',
      availableHint: 'Você recebe as conversas transferidas pela IA.',
      awayHint: 'Pausa: a IA avisa o cliente que a equipe responde depois.',
      waiting: 'Aguardando: {{count}}',
      newTicket: 'Novo chamado aguardando atendimento (na fila: {{count}})',
      changeFailed: 'Não foi possível alterar seu status.',
      team: {
        available: 'Equipe online agora ({{count}})',
        outsideHours: 'Fora do horário de atendimento — clientes são respondidos {{when}}',
        nobodyOnline: 'Ninguém disponível agora — clientes deixam mensagem e abrem chamado',
      },
    },
    analytics: {
      title: 'Analytics',
      subtitle: 'Métricas reais do seu atendimento e dos agentes, no período escolhido.',
      loading: 'Carregando métricas...',
      loadFailed: 'Não foi possível carregar as métricas.',
      unavailable: '—',
      notAvailable: 'Ainda não disponível',
      window: {
        label: 'Período',
        last7: 'Últimos 7 dias',
        last30: 'Últimos 30 dias',
        last90: 'Últimos 90 dias',
      },
      export: {
        button: 'Exportar CSV',
        columns: {
          day: 'Dia',
          executions: 'Execuções',
          succeeded: 'Sucessos',
          failed: 'Falhas',
          promptTokens: 'Tokens de entrada',
          completionTokens: 'Tokens de saída',
        },
      },
      units: {
        ms: '{{value}} ms',
        percent: '{{value}}%',
      },
      empty: {
        title: 'Ainda não há métricas para mostrar',
        description:
          'Assim que seu atendimento começar a receber e analisar conversas, os números reais aparecem aqui.',
      },
      agent: {
        section: 'Atividade do agente',
        total: 'Análises do agente',
        succeeded: 'Concluídas',
        failed: 'Falhas',
        successRate: 'Taxa de sucesso',
        suggestions: 'Sugestões ao operador',
        suggestionsHint: 'Vezes em que o agente escalou para um humano com uma sugestão privada.',
        autoReplies: 'Respostas automáticas',
        autoRepliesHint:
          'Vezes em que o agente respondeu sozinho ao cliente (modo resposta automática).',
        avgLatency: 'Latência média',
        p95Latency: 'Latência p95',
        byMode: 'Por modo',
        byModel: 'Por modelo',
        daily: 'Análises por dia',
        dailyAria: 'Execuções do agente por dia, empilhadas por concluídas e falhas.',
        emptyTitle: 'O agente ainda não analisou nenhuma conversa',
        emptyDescription: 'Quando chegarem mensagens, as análises do agente aparecem aqui.',
        modes: {
          ObserveOnly: 'Somente observação',
          Suggest: 'Sugerindo',
          AutoReply: 'Resposta automática',
        },
      },
      handoffs: {
        title: 'Transferências para humano',
        description:
          'Um funil completo de transferências ainda não está disponível. Enquanto isso, mostramos o sinal real de escalonamento: as sugestões enviadas ao operador.',
      },
      inbound: {
        section: 'Mensagens recebidas',
        total: 'Mensagens recebidas',
        avgProcessing: 'Tempo médio de processamento',
        byStatus: 'Por status',
        failures: 'Falhas de processamento',
        noFailures: 'Nenhuma falha no período.',
        emptyTitle: 'Nenhuma mensagem recebida no período',
        emptyDescription: 'As mensagens dos seus clientes aparecem aqui assim que chegarem.',
        statuses: {
          Pending: 'Na fila',
          Processed: 'Processadas',
          Skipped: 'Ignoradas',
          Failed: 'Falharam',
        },
      },
      knowledge: {
        section: 'Conhecimento',
        documents: 'Documentos',
        ready: 'Prontos',
        processing: 'Processando',
        pending: 'Na fila',
        failed: 'Com falha',
        chunks: 'Trechos indexados',
        emptyTitle: 'Nenhum documento na base',
        emptyDescription: 'Adicione documentos para o agente responder com precisão.',
        addAction: 'Adicionar documentos',
      },
      channels: {
        section: 'Canais',
        emptyTitle: 'Nenhum canal conectado',
        emptyDescription: 'Conecte o WhatsApp para acompanhar a saúde do seu canal aqui.',
        connectAction: 'Conectar canal',
        statuses: {
          Created: 'Criado',
          WaitingForPairing: 'Aguardando conexão',
          Connected: 'Conectado',
          Disconnected: 'Desconectado',
          Failed: 'Com falha',
        },
        types: {
          WhatsApp: 'WhatsApp',
          WebChat: 'WebChat',
          Email: 'E-mail',
          Instagram: 'Instagram',
          Telegram: 'Telegram',
          Teams: 'Teams',
          Api: 'API',
        },
      },
      usage: {
        section: 'Uso',
        agents: 'Agentes',
        channels: 'Canais',
        users: 'Pessoas',
        documents: 'Documentos',
        aiExecutions: 'Análises de IA',
        promptTokens: 'Tokens de entrada',
        completionTokens: 'Tokens de saída',
        totalTokens: 'Tokens no total',
        tokensNotAvailable: 'Tokens ainda não registrados',
      },
    },
    audit: {
      title: 'Auditoria',
      subtitle: 'Quem fez o quê, quando e em qual recurso.',
      loading: 'Carregando auditoria...',
      loadFailed: 'Não foi possível carregar a auditoria.',
      empty: {
        title: 'Nenhum registro de auditoria',
        description: 'As ações da sua equipe aparecem aqui assim que acontecerem.',
        filteredTitle: 'Nenhum resultado para estes filtros',
        filteredDescription: 'Ajuste o período ou o tipo de ator para ver mais registros.',
      },
      filters: {
        actorType: 'Tipo de ator',
        all: 'Todos',
        clear: 'Limpar filtros',
        from: 'De',
        to: 'Até',
        correlationId: 'Correlação',
        correlationIdPlaceholder: 'Buscar por ID...',
        invalidRange: 'A data inicial não pode ser posterior à final.',
      },
      export: {
        button: 'Exportar CSV',
        truncated:
          'Exportamos os primeiros {{max}} registros. Refine os filtros para exportar menos.',
        failed: 'Não foi possível exportar a auditoria.',
      },
      actorTypes: {
        User: 'Pessoa',
        System: 'Sistema',
        Agent: 'Agente',
        PlatformAdministrator: 'Administrador da plataforma',
      },
      table: {
        timestamp: 'Data e hora',
        actor: 'Ator',
        action: 'Ação',
        resource: 'Recurso',
        correlation: 'Correlação',
        viewDetail: 'Ver detalhes',
      },
      actions: {
        tenant: {
          created: 'Organização criada',
        },
        conversation: {
          replied: 'Resposta enviada ao cliente',
          note_added: 'Nota interna adicionada',
          resolved: 'Conversa resolvida',
          reopened: 'Conversa reaberta',
        },
      },
      resources: {
        Tenant: 'Organização',
        Conversation: 'Conversa',
      },
      detail: {
        title: 'Detalhe do registro',
        occurredAt: 'Data e hora',
        actor: 'Ator',
        action: 'Ação',
        resource: 'Recurso',
        correlation: 'Correlação',
        metadata: 'Metadados',
        noMetadata: 'Sem metadados para este registro.',
        close: 'Fechar',
      },
      pagination: {
        summary: '{{from}}–{{to}} de {{total}}',
        prev: 'Anterior',
        next: 'Próxima',
      },
      unknownActor: 'Sistema',
    },
    modules: {
      desk: {
        title: 'Atendimento',
        description: 'Selecione uma organização para ver as conversas.',
      },
      pendencias: {
        title: 'Pendências',
        description: 'Selecione uma organização para ver as pendências.',
      },
      agents: {
        title: 'Agentes',
        description: 'Selecione uma organização para ver seus agentes.',
      },
      knowledge: {
        title: 'Conhecimento',
        description: 'Selecione uma organização para gerenciar o conhecimento.',
      },
      channels: {
        title: 'Canais',
        description: 'Selecione uma organização para ver seus canais.',
      },
      integrations: {
        title: 'Integrações',
        description: 'Selecione uma organização para ver as integrações.',
      },
      analytics: {
        title: 'Analytics',
        description: 'Selecione uma organização para ver as métricas.',
      },
      settings: {
        title: 'Configurações',
        description: 'Selecione uma organização para ajustar as preferências.',
      },
    },
    team: {
      title: 'Equipe',
      subtitle: 'Pessoas com acesso a esta organização.',
      you: '(você)',
      roleLabel: 'Papel',
      statusLabel: 'Status',
      memberLabel: 'Membro',
      membersCaption: 'Membros da equipe',
      actionsLabel: 'Ações',
      remove: 'Remover',
      actionFailed: 'Não foi possível concluir a ação.',
      removeConfirm: {
        title: 'Remover membro?',
        description:
          '{{name}} perderá o acesso a esta organização. Você pode convidá-lo novamente depois.',
        confirm: 'Remover',
        cancel: 'Cancelar',
      },
      toast: {
        roleChanged: 'Papel atualizado',
        removed: '{{name}} foi removido da equipe',
        invited: 'Convite enviado para {{email}}',
        invitationRevoked: 'Convite revogado',
      },
      invite: {
        title: 'Convidar por e-mail',
        subtitle: 'A pessoa recebe um link para entrar com o papel escolhido.',
        emailLabel: 'E-mail',
        emailPlaceholder: 'pessoa@empresa.com',
        submit: 'Enviar convite',
        submitting: 'Enviando...',
      },
      pending: {
        title: 'Convites pendentes',
        expiresAt: 'expira em {{date}}',
        expired: 'Expirado',
        revoke: 'Revogar',
      },
      link: {
        title: 'Link do convite',
        subtitle:
          'Enviamos por e-mail para {{email}}. Você também pode copiar o link e compartilhar.',
        note: 'O link é mostrado uma vez. Se precisar, gere um novo convite.',
        linkLabel: 'Link do convite',
        copy: 'Copiar',
        copied: 'Copiado!',
        copyFailed: 'Falhou — selecione e copie',
        done: 'Concluído',
      },
      noPermission: {
        title: 'Você não tem acesso à equipe',
        description:
          'Fale com um administrador da sua organização para gerenciar quem faz parte do time.',
      },
      roles: {
        Owner: 'Dono',
        Administrator: 'Administrador',
        Supervisor: 'Supervisor',
        Agent: 'Atendente',
        Analyst: 'Analista',
      },
      statuses: {
        Invited: 'Convidado',
        Active: 'Ativo',
        Suspended: 'Suspenso',
        Revoked: 'Revogado',
      },
    },
    acceptInvite: {
      working: 'Processando seu convite...',
      success: 'Convite aceito. Bem-vindo à equipe!',
      alreadyMember: 'Você já faz parte desta organização.',
      errorTitle: 'Não foi possível aceitar o convite',
      genericError: 'O convite é inválido ou expirou.',
      backHome: 'Voltar ao início',
    },
    settings: {
      pageTitle: 'Configurações',
      pageSubtitle: 'Gerencie os dados da sua organização e as preferências da interface.',
      triage: {
        title: 'Triagem',
        description:
          'Um assistente que lê suas conversas do WhatsApp, diz de quem é a vez, resume, prioriza e sugere um rascunho — você decide o que enviar. Nada é enviado sem a sua ação.',
        loadFailed: 'Não foi possível carregar a configuração da triagem.',
        saveFailed: 'Não foi possível salvar a configuração da triagem.',
        save: 'Salvar',
        saved: 'Configuração salva',
        general: {
          title: 'Assistente de pendências',
          enable: 'Ligar a triagem',
          enableHint:
            'Analisa as conversas quando ficam em silêncio e mostra as pendências em Pendências.',
          transcribe: 'Transcrever áudios',
          transcribeHint: 'Áudios recebidos viram texto para a triagem e para o atendimento.',
          quietWindow: 'Janela de silêncio (minutos)',
          quietWindowHint: 'Espera a conversa ficar quieta antes de analisar (1 a 30 minutos).',
        },
        digest: {
          title: 'Resumo diário',
          enable: 'Receber um resumo diário no WhatsApp',
          enableHint:
            'Uma mensagem por dia, no horário escolhido, com o que espera você e as tarefas abertas.',
          time: 'Horário',
          timeZone: 'Fuso horário',
          recipient: 'Número destinatário',
          recipientPlaceholder: 'Somente dígitos, com DDI e DDD',
          recipientHint: 'Deixe vazio para usar o número do canal.',
          sendNow: 'Enviar resumo agora',
          sendNowHint:
            'Envia o resumo de hoje já, pelo WhatsApp, para você conferir. Não altera o envio agendado.',
          sendNowDirty: 'Salve as alterações antes de enviar o resumo.',
          sendNowSent: 'Resumo enviado',
          sendNowFailed: 'Não foi possível enviar o resumo.',
          lastSent: 'Último resumo enviado em {{date}}.',
          lastError: {
            title: 'O último resumo não saiu',
            recipientUnavailable:
              'Nenhum número destinatário: informe um número acima ou conecte o canal de WhatsApp.',
            channelUnavailable: 'Nenhum canal de WhatsApp conectado para enviar o resumo.',
            sendFailed:
              'O canal não conseguiu enviar o resumo. Vamos tentar de novo no próximo ciclo.',
            unknown: 'O resumo não pôde ser enviado. Vamos tentar de novo no próximo ciclo.',
          },
        },
      },
      handoff: {
        title: 'Atendimento humano',
        description:
          'Quando a IA transfere para a equipe: em que horário vocês atendem, o que o cliente lê e quem é avisado. Fora do horário ou sem ninguém disponível, o cliente deixa a mensagem e um chamado fica na fila.',
        loadFailed: 'Não foi possível carregar as configurações de atendimento.',
        teamNow: 'Agora:',
        hours: {
          title: 'Horário de atendimento',
          enable: 'Usar horário de atendimento',
          enabledHint:
            'Fora destes horários o cliente é avisado de quando a equipe volta, mesmo que alguém esteja online.',
          disabledHint:
            'Sem horário definido: a equipe atende sempre que houver alguém com status Disponível.',
          timeZone: 'Fuso horário',
          until: 'até',
          opens: 'Início do atendimento de {{day}}',
          closes: 'Fim do atendimento de {{day}}',
          closed: 'Fechado',
          addWindow: 'Adicionar intervalo',
          removeWindow: 'Remover intervalo',
          noWindows: 'Marque ao menos um dia de atendimento.',
          inverted: 'Cada intervalo precisa terminar depois de começar.',
          overlap: 'Os intervalos de um mesmo dia não podem se sobrepor.',
        },
        messages: {
          title: 'Mensagens ao cliente na transferência',
          hint: 'Deixe em branco para usar o texto padrão. Use {protocolo} para o número do chamado e {retorno} para quando a equipe volta (ex.: "amanhã a partir das 08:00").',
          available: 'Com a equipe disponível',
          unavailable: 'Sem ninguém disponível ou fora do horário',
        },
        notify: {
          label: 'Avisar a equipe por e-mail',
          hint: 'Quando um chamado for aberto sem ninguém disponível, quem atende conversas recebe um e-mail com o link.',
        },
        save: 'Salvar',
        saved: 'Configurações de atendimento salvas',
        saveFailed: 'Não foi possível salvar.',
        days: {
          monday: 'Segunda-feira',
          tuesday: 'Terça-feira',
          wednesday: 'Quarta-feira',
          thursday: 'Quinta-feira',
          friday: 'Sexta-feira',
          saturday: 'Sábado',
          sunday: 'Domingo',
        },
        timeZones: {
          America_Sao_Paulo: 'Brasília (São Paulo, Rio, Sul, GO, DF)',
          America_Bahia: 'Bahia',
          America_Fortaleza: 'Fortaleza (CE, RN, PB, MA, PI)',
          America_Recife: 'Recife (PE)',
          America_Belem: 'Belém (PA, AP)',
          America_Manaus: 'Manaus (AM)',
          America_Cuiaba: 'Cuiabá (MT)',
          America_Campo_Grande: 'Campo Grande (MS)',
          America_Porto_Velho: 'Porto Velho (RO)',
          America_Boa_Vista: 'Boa Vista (RR)',
          America_Rio_Branco: 'Rio Branco (AC)',
          America_Noronha: 'Fernando de Noronha',
        },
      },
      organization: {
        title: 'Organização',
        description:
          'Dados da sua organização. O nome e o identificador são definidos pela equipe.',
        nameLabel: 'Nome',
        slugLabel: 'Identificador',
        statusLabel: 'Status',
        statuses: {
          Provisioning: 'Provisionando',
          Active: 'Ativa',
          Suspended: 'Suspensa',
          Disabled: 'Desativada',
          Deleted: 'Excluída',
        },
        website: {
          label: 'Site da empresa',
          hint: 'Seu agente usa o site para aprender sobre o seu negócio.',
          placeholder: 'minhaempresa.com.br',
          empty: 'Nenhum site cadastrado ainda.',
          save: 'Salvar site',
          saved: 'Site atualizado.',
          invalid: 'Informe um site válido (ex.: minhaempresa.com.br).',
          error: 'Não foi possível salvar o site. Tente novamente.',
        },
      },
      language: {
        title: 'Idioma da interface',
        description: 'Escolha o idioma em que o produto é exibido para você.',
        groupLabel: 'Idioma da interface',
        current: 'Atual',
        options: {
          ptBR: 'Português (Brasil)',
          enUS: 'English',
        },
      },
      account: {
        title: 'Conta',
        description: 'A conta com que você está conectado.',
        nameLabel: 'Nome',
        emailLabel: 'E-mail',
      },
      security: {
        title: 'Segurança',
        description: 'Altere a senha da sua conta.',
        currentLabel: 'Senha atual',
        newLabel: 'Nova senha',
        newHint: 'Mínimo de 12 caracteres, com maiúscula, minúscula e número.',
        confirmLabel: 'Confirmar nova senha',
        submit: 'Alterar senha',
        success: 'Senha alterada com sucesso.',
        errors: {
          currentRequired: 'Informe sua senha atual.',
          newLength: 'A nova senha deve ter pelo menos 12 caracteres.',
          mismatch: 'As senhas não coincidem.',
        },
      },
      dangerZone: {
        title: 'Zona de perigo',
        description:
          'Excluir a organização é irreversível: remove o acesso de toda a equipe e desliga o atendimento.',
        deleteButton: 'Excluir organização',
        confirmTitle: 'Excluir esta organização?',
        confirmDescription:
          'Esta ação não pode ser desfeita. A equipe perde o acesso e o atendimento é desligado.',
        confirmPrompt: 'Digite {{slug}} para confirmar',
        confirmButton: 'Excluir definitivamente',
      },
    },
    landing: {
      nav: {
        produto: 'Produto',
        como: 'Como funciona',
        controle: 'Controle',
        planos: 'Planos',
        duvidas: 'Dúvidas',
        login: 'Entrar',
        signup: 'Criar conta',
      },
      brand: {
        mark: 'C',
        productTag: 'Produto Codout · SaaS',
      },
      hero: {
        badge: 'IA treinada no conhecimento da sua empresa',
        titleLine1: 'Seu atendimento responde',
        titleHighlight: 'em segundos, com precisão',
        subtitle:
          'Conecte o WhatsApp, aponte o seu site e o agente aprende sozinho. Ele sugere a resposta com a fonte ao lado, e sua equipe aprova com um clique — até você decidir deixá-lo responder direto.',
        ctaPrimary: 'Criar meu agente',
        ctaSecondary: 'Ver como funciona',
        trustNoCard: 'Sem cartão de crédito',
        trustFirstAgent: 'Primeiro agente em minutos',
        trustIsolatedData: 'Dados isolados por empresa',
        industriesLabel: 'Feito para quem atende no WhatsApp',
        industry1: 'E-commerce',
        industry2: 'Serviços recorrentes',
        industry3: 'Software B2B',
        industry4: 'Saúde e clínicas',
        industry5: 'Educação',
        webchat: {
          siteTag: 'site do cliente',
          agentInitial: 'AU',
          agentName: 'Aurora',
          agentStatus: 'online · responde na hora',
          greetingHello: 'Olá,',
          customerName: 'Clovis',
          greetingSeen: '! Vi que você está no plano',
          planName: 'Pro',
          greetingHelp: '. Como posso ajudar hoje?',
          customerAsk: 'meu pedido já saiu?',
          answerPrefix: 'Sim! Seu pedido',
          orderNumber: '#4821',
          answerSuffix: 'saiu para entrega hoje às 09h14 e chega até as 18h.',
          sourceLabel: 'consultado ao vivo ·',
          sourceTool: 'pedidos',
          quickReply1: 'Rastrear entrega',
          quickReply2: 'Ver meus pedidos',
          quickReply3: 'Falar com atendente',
          inputPlaceholder: 'Escreva sua mensagem…',
          poweredBy: 'Powered by',
          handoffTitle: 'Encaminhado para a equipe',
          handoffDesc: 'Histórico e motivo já com o atendente humano.',
          handoffEtaLabel: 'resposta média',
          handoffEta: '2 min',
        },
      },
      product: {
        eyebrow: 'O que muda na sua operação',
        title: 'Menos espera para o cliente, menos trabalho repetido para a equipe',
        subtitle:
          'O agente cuida do que é repetitivo e sempre mostra de onde tirou a informação. O que exige gente continua com gente, com o contexto pronto.',
        stat1Value: '1º',
        stat1Title: 'Resposta no mesmo minuto',
        stat1Desc:
          'A sugestão fica pronta antes de alguém abrir a conversa. Aprovar leva um clique.',
        stat2Value: '100%',
        stat2Title: 'Rastreável',
        stat2Desc:
          'Cada resposta cita documento, trecho e consulta usada. Cada alteração fica auditada.',
        stat3Value: '0',
        stat3Title: 'Automação sem aviso',
        stat3Desc:
          'Resposta automática só existe quando você liga, e o modo atual aparece em toda tela.',
        stat4Value: '1',
        stat4Title: 'Lugar para operar',
        stat4Desc: 'Conversas, conhecimento, integrações e equipe no mesmo painel.',
      },
      howItWorks: {
        eyebrow: 'Como funciona',
        title: 'Do cadastro ao primeiro atendimento',
        subtitle: 'Quatro passos, nenhum deles técnico.',
        step1Number: '01',
        step1Title: 'Conte sobre a empresa',
        step1Desc: 'Nome, site e segmento. Menos de um minuto.',
        step2Number: '02',
        step2Title: 'O agente aprende',
        step2Desc:
          'Lemos as páginas públicas, identificamos produtos e organizamos as dúvidas frequentes.',
        step3Number: '03',
        step3Title: 'Você testa antes',
        step3Desc: 'Converse com ele no Playground e ajuste o tom antes de qualquer cliente.',
        step4Number: '04',
        step4Title: 'Conecte o WhatsApp',
        step4Desc: 'Leia o QR code e comece a atender no canal que seus clientes já usam.',
      },
      featureSuggestion: {
        eyebrow: 'Sugestão com fonte',
        title: 'A equipe vê a resposta e de onde ela veio',
        desc: 'Nada de resposta que ninguém sabe explicar. O painel mostra o documento, o trecho e a consulta feita no seu sistema, com o tempo de cada etapa.',
        bullet1: 'Aprovar, editar ou descartar em um clique',
        bullet2: 'Notas internas separadas da conversa do cliente',
        bullet3: 'Histórico e contexto do cliente na mesma tela',
        mockLabel: 'Sugestão do agente',
        mockText:
          'A troca por tamanho pode ser feita em até 30 dias após a entrega, com a etiqueta original. Quer que eu abra o pedido?',
        sourceCardTitle: 'Política de trocas · trecho 4',
        sourceCardQuote: '"A troca pode ser solicitada pelo site em até 30 dias…"',
        toolBadge: 'LEITURA',
        toolCode: 'consultar_pedido(48213)',
        toolLatency: '✓ 320 ms',
      },
      featureKnowledge: {
        eyebrow: 'Conhecimento vivo',
        title: 'Ele avisa quando falta informação',
        desc: 'Site, PDFs, FAQ e textos colados viram base de conhecimento. Quando um cliente pergunta algo que ninguém documentou, o assunto aparece como lacuna — com quantas vezes foi perguntado.',
        link: 'Ver a tela de conhecimento →',
        row1Label: 'Produtos',
        row1Status: 'COMPLETO',
        row2Label: 'Prazos e entrega',
        row2Status: 'COMPLETO',
        row3Label: 'Trocas',
        row3Status: 'PARCIAL',
        row4Label: 'Cancelamento',
        row4Meta: 'perguntado 9× sem resposta na base',
        row4Action: 'Preencher',
      },
      featureActions: {
        eyebrow: 'Ações nos seus sistemas',
        title: 'Consultas reais, sem abrir a porteira',
        desc: 'Importe a especificação da sua API e escolha o que o agente pode fazer. Cada operação recebe um nível de risco: leitura é liberada, escrita pede confirmação, destrutiva vem desligada.',
        link: 'Ver o assistente de integração →',
        tool1Badge: 'LEITURA',
        tool1Code: 'consultar_pedido',
        tool1Status: 'liberada',
        tool2Badge: 'ESCRITA',
        tool2Code: 'atualizar_endereco',
        tool2Status: 'com confirmação',
        tool3Badge: 'DESTRUTIVA',
        tool3Code: 'cancelar_contrato',
        tool3Status: 'desativada',
      },
      control: {
        eyebrow: 'Controle e confiança',
        title: 'Você decide quanto a IA pode fazer',
        subtitle:
          'Três níveis de automação, trocados quando você quiser. O nível atual fica visível em toda tela crítica e cada mudança entra na auditoria.',
        level1Badge: 'Observando',
        level1Title: 'Só acompanha',
        level1Desc: 'Ideal na primeira semana: ele aprende com as conversas sem interferir.',
        level2Badge: 'Sugerindo · recomendado',
        level2Title: 'Prepara, você aprova',
        level2Desc: 'A equipe ganha velocidade sem perder a palavra final.',
        level3Badge: 'Resposta automática',
        level3Title: 'Responde o que domina',
        level3Desc: 'Exige confirmação para ativar e nunca vem ligada por padrão.',
        guarantee1Title: 'Transferência com contexto',
        guarantee1Desc:
          'Casos sensíveis vão para a equipe com o motivo, o histórico e a IA pausada.',
        guarantee2Title: 'Papéis por pessoa',
        guarantee2Desc:
          'Proprietária, supervisor, atendente e analista, cada um com o que precisa.',
        guarantee3Title: 'Auditoria completa',
        guarantee3Desc: 'Quem fez, o que mudou, quando e em qual recurso.',
        guarantee4Title: 'Dados isolados',
        guarantee4Desc: 'Cada empresa com seus dados separados e credenciais cifradas.',
      },
      channels: {
        eyebrow: 'Canais e integrações',
        title: 'Disponível hoje, e o que vem depois',
        card1Title: 'WhatsApp',
        card1Desc: 'Conexão por QR code, pronta para uso.',
        card1Status: 'DISPONÍVEL',
        card2Title: 'API própria',
        card2Desc: 'Importe sua especificação e escolha as operações.',
        card2Status: 'DISPONÍVEL',
        card3Title: 'WhatsApp Business oficial',
        card3Desc: 'Conta verificada e templates.',
        card3Status: 'EM BREVE',
        card4Title: 'WebChat, e-mail, Instagram',
        card4Desc: 'Mesmos agentes, novos canais.',
        card4Status: 'PLANEJADO',
      },
      pricing: {
        title: 'Planos',
        badge: 'PREÇOS PROVISÓRIOS',
        subtitle: 'Valores em definição. A estrutura de limites abaixo já reflete o produto.',
        subtitlePriced:
          'Preço mensal fixo, sem fidelidade. Comece pelo teste grátis e assine quando quiser.',
        priceUnset: '—',
        pricePeriod: '/mês',
        starterName: 'Starter',
        starterDesc: 'Para começar a atender com IA',
        starterFeature1: '1 canal WhatsApp',
        starterFeature2: '1 agente',
        starterFeature3: 'Conhecimento básico',
        starterFeature4: 'Cota de IA limitada',
        starterCta: 'Começar',
        professionalName: 'Professional',
        professionalBadge: 'MAIS ESCOLHIDO',
        professionalDesc: 'Para operação de suporte completa',
        professionalFeature1: 'Múltiplos canais e agentes',
        professionalFeature2: 'Ferramentas e integrações',
        professionalFeature3: 'Analytics e auditoria',
        professionalFeature4: 'Cota de IA ampliada',
        professionalCta: 'Criar conta',
        enterpriseName: 'Enterprise',
        enterpriseDesc: 'Para requisitos corporativos',
        enterprisePrice: 'Sob consulta',
        enterpriseFeature1: 'SSO e auditoria avançada',
        enterpriseFeature2: 'SLA e ferramentas sob medida',
        enterpriseFeature3: 'WhatsApp oficial',
        enterpriseFeature4: 'Implantação dedicada',
        enterpriseCta: 'Falar com vendas',
      },
      faq: {
        title: 'Dúvidas antes de começar',
        q1: 'A IA vai responder errado para o meu cliente?',
        a1: 'No modo recomendado, nenhuma mensagem é enviada sem alguém aprovar. E toda sugestão vem com a fonte, então dá para conferir em segundos.',
        q2: 'Preciso de alguém técnico para configurar?',
        a2: 'Não. O cadastro pede nome, site e segmento; o resto é sugerido. Conectar o WhatsApp é ler um QR code. Integrar sua API é opcional e guiado em etapas.',
        q3: 'O que acontece quando ele não sabe?',
        a3: 'Ele transfere para a equipe com o motivo e o histórico, e registra o assunto como lacuna de conhecimento para você preencher depois.',
        q4: 'Meus dados ficam misturados com de outras empresas?',
        a4: 'Não. Cada empresa tem seus dados isolados, com permissões por papel e credenciais de integração armazenadas cifradas.',
        q5: 'Posso usar meu número atual?',
        a5: 'Recomendamos um número dedicado ao atendimento, para separar o pessoal do comercial. A conexão é feita pelo aparelho que atende seus clientes.',
      },
      finalCta: {
        title: 'Coloque seu agente para conversar hoje',
        subtitle:
          'Crie a conta, aponte seu site e teste o agente antes de conectar qualquer canal. Sem cartão, sem consultor.',
        subtitleTrial:
          'Teste grátis com {{credits}} interações por {{days}} dias. Sem cartão, sem consultor.',
        ctaPrimary: 'Criar conta gratuita',
        ctaSecondary: 'Ver o produto por dentro',
      },
      footer: {
        copyright: '© {{year}} {{productName}}',
        security: 'Segurança',
        allScreens: 'Todas as telas',
      },
    },
  },
}

/** Forma canonica dos recursos de traducao: pt-BR e a referencia, en-US precisa cobrir as mesmas chaves. */
export type AppResources = typeof ptBR
